import { __rest, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var MarketingOutline = function (_a) {
  var _b = _a.fill,
    fill = _b === void 0 ? 'currentColor' : _b,
    props = __rest(_a, ["fill"]);
  return React__default.createElement("svg", __assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M15.8333 2.5L15 4.16667L7.5 6.66667H4.16667C3.25 6.66667 2.5 7.41667 2.5 8.33333V11.6667C2.5 12.5833 3.25 13.3333 4.16667 13.3333H5.83333V17.5H7.5V13.3333L15 15.8333L15.8333 17.5H17.5V11.4355C17.9964 11.147 18.3333 10.6158 18.3333 10C18.3333 9.38421 17.9964 8.85301 17.5 8.56445V2.5H15.8333ZM15.8333 5.64616V14.3538L15.5273 14.2513L9.16667 12.1322V7.86784L15.5273 5.7487L15.8333 5.64616ZM4.16667 8.33333H7.5V11.6667H5.83333H4.16667V8.33333Z",
    fill: fill
  }));
};
export { MarketingOutline as default };
//# sourceMappingURL=MarketingOutline.js.map
